import { FlowContextSme } from '../context';

const usageEstimates: FlowContextSme[] = [
  {
    industry: 'BedrijfAanHuis',
    usageElectricityHigh: 12.75,
    usageElectricityLow: 12.75,
    usageGas: 15.83,
  },
  {
    industry: 'Bouwbedrijf',
    usageElectricityHigh: 46.5,
    usageElectricityLow: 46.5,
    usageGas: 23.0,
  },
  {
    industry: 'Detailhandel',
    usageElectricityHigh: 20.12,
    usageElectricityLow: 20.12,
    usageGas: 12.4,
  },
  {
    industry: 'Horeca',
    usageElectricityHigh: 52.65,
    usageElectricityLow: 52.65,
    usageGas: 21.07,
  },
  {
    industry: 'Productie',
    usageElectricityHigh: 7.48,
    usageElectricityLow: 7.48,
    usageGas: 12.38,
  },
  {
    industry: 'Overige',
    usageElectricityHigh: 19.14,
    usageElectricityLow: 19.14,
    usageGas: 14.08,
  },
  {
    industry: 'Zorginstelling',
    usageElectricityHigh: 42.0,
    usageElectricityLow: 42.0,
    usageGas: 37.0,
  },
];

export default usageEstimates;
